export function isUrl(string){
  try {
    new URL(string);
  } catch (e) {
    // console.error(e);
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/modules/helpers.js